<footer class="pt-3 pt-md-4 border-top">

  <div class="footer-bottom-bar">
    <!-- <div class="container">
      <div class="row mb-4 footer-responsive">

        <div class="col-3 col-md ">
          <div class="text-block-12"> Dirección Física </div>
          <div>
            Centro Medico Norte <br>
            Calle Periferial <br>
            Interior, <br>
            Bo. Monacillos Rio<br>
            Piedras, PR<br>
            Tel. Oficina Central<br>
            787-765-2929
          </div>
        </div>


        <div class="col-3 col-md">
          <div class="text-block-12"> Dirección Postal</div>
          <div>
            Centro Medico Norte <br>
            Calle Periferial <br>
            Interior, <br>
            Bo. Monacillos Rio<br>
            Piedras, PR<br>
            Tel. Oficina Central<br>
            787-765-2929
          </div>
        </div>

        <div class="col-3 col-md">
          <div class="text-block-12"> Información </div>
          <div>
            <a class="link" target="_blank" href="http://www.pr.gov/Pages/terminos-condiciones.aspx"> Términos y
              Condiciones </a>
          </div>
          <div>
            <a class="link" target="_blank" href="https://oig.pr.gov/informa/"> Oficina del Inspector General (OIG) </a>
          </div>
          <div>
            <a class="link" target="_blank" href="mailto:webmaster@ogp.pr.gov"> webmaster </a>
          </div>
        </div>
      </div>


      <div class="row mb-4 footer-responsive">

        <div class="col-3 col-md">
        </div>
        <div class="col-3 col-md sello-oficial">
          <div class="slogan">GOBIERNO DE PUERTO RICO


          </div>
          <div class="agency-name">
          </div>
        </div>

        <div class="col-3 col-md">
          <i class="fa fa-wheelchair" aria-hidden="true">
          </i>
          Accesibilidad Núm-###-2019 - Conforme a la Ley 229 de 2003<br>
          <i class="far fa-copyright" aria-hidden="true">
          </i>

        </div>
      </div>

      <div class="row mb-4 footer-responsive">
        <div class="col-12 text-right">
          <p *ngIf="this.buildVersion.length > 0">Last build date: {{ this.buildVersion }}</p>
        </div>
      </div>
    </div> -->

    <div class="row pb-4">
      <!-- Columna de dirección - responsiva -->
      <div class="col-12 col-md-6 col-lg-4 mb-4 mb-lg-0">
        <div class="text-block-12"> Dirección Física </div>
        <div class="address-info mt-4">
          Monacillos Building Center
          Carr. 8828, km 6.3, Río Piedras, PR 00936
        </div>
        <div class="email-info mt-4">
          contactus@salud.pr.gov
        </div>
      </div>

      <!-- Columna de redes sociales - responsiva -->
      <div class="col-12 col-md-6 col-lg-4 mb-4 mb-lg-0">
        <div class="text-block-12"> Social Media</div>
        <div class="social-media-info mt-4">
          <div class="icon-media-container">
            <div class="img-container" (click)="goToFacebook()">
              <img src="assets/images/salud/icons/facebook.svg" alt="Facebook" class="icon-media">
            </div>
            <div class="img-container" (click)="goToInstagram()">
              <img src="assets/images/salud/icons/instagram.svg" alt="Instagram" class="icon-media">
            </div>
            <div class="img-container" (click)="goToX()">
              <img src="assets/images/salud/x-logo.png" alt="X" class="icon-media" style="border-radius: 50%;">
            </div>
          </div>
        </div>
      </div>

      <!-- Columna de Prgov Salud - responsiva -->
      <div class="col-12 col-lg-4 border-left border-left-responsive pb-3 pl-4">
        <div class="text-block-12 pl-2"> Prgov Salud </div>
        <div class="mt-4 pl-2">
          <div class="portal-logo">
            <img src="assets/images/salud/logo-footer.png" alt="PRGOV SALUD" class="img-fluid">
            <a class="text-white" href="https://www.salud.pr.gov" target="_blank">Departamento de Salud de Puerto Rico</a>
          </div>

          <div class="terms-container mt-2">
            <mat-icon>library_books</mat-icon>
            <a class="text-white" href="https://www.prits.pr.gov/politica-de-privacidad" target="_blank">Política de Privacidad</a>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Nueva sección en la parte inferior del footer - responsiva -->
  <div class="footer-copyright-bar">
    <div class="container">
      <div class="text-center py-2">
        © 2025 Departamento de Salud de Puerto Rico. Todos los derechos reservados.

        <p *ngIf="this.buildVersion.length > 0">Last build date: {{ this.buildVersion }}</p>
      </div>
    </div>
  </div>

</footer>
